.wrap {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.select {
  height: 28px;
  padding: 0 10px;
  font-size: 13px;
  color: var(--text);
  background: var(--input-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-pill);
  cursor: pointer;
  max-width: 200px;
}

.select:hover {
  border-color: var(--blue);
}
.select:disabled {
  cursor: default;
  opacity: 0.6;
}

/* Объект без дивизиона выделен: он не попадёт ни в одну зону
   ответственности и не учтётся в рейтинге — это стоит заметить. */
.unset {
  color: var(--warn);
  border-color: var(--warn);
}

/* Для тех, кто не управляет дивизионами — просто подпись */
.plain {
  padding: 3px 10px;
  font-size: 12.5px;
  color: var(--text2);
  background: var(--table-even);
  border-radius: var(--r-pill);
}

.hint {
  font-size: 12px;
  color: var(--text2);
}
.error {
  font-size: 12px;
  color: var(--err);
  cursor: help;
}
